import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import FacilityAddress from '../FacilityAddress';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    internalName: PropTypes.string.isRequired,
    primary: PropTypes.shape({
      title: PropTypes.string.isRequired,
      internalName: PropTypes.string.isRequired,
    }),
  }).isRequired,
  titleOverride: PropTypes.string,
  useInternalName: PropTypes.bool,
};

const defaultProps = {
  className: undefined,
  titleOverride: undefined,
  useInternalName: undefined,
};

const PageTitle = ({
  className,
  page: {
    title,
    internalName,
    primary: {
      title: primaryTitle,
      internalName: primaryInternalName,
    } = {},
    facility,
  },
  titleOverride,
  useInternalName,
}) => {
  const name = useInternalName ? internalName : title;
  const primaryName = useInternalName ? primaryInternalName : primaryTitle;

  if (!(primaryInternalName || primaryTitle)) {
    return (
      <div className={className}>
        {titleOverride || name}
        {facility && <FacilityAddress facility={facility} />}
      </div>
    );
  }

  return (
    <div className={className}>
      {primaryName}
      <div className={styles.withParentName}>
        {titleOverride || name}
      </div>
      {facility && <FacilityAddress facility={facility} />}
    </div>
  );
};

PageTitle.propTypes = propTypes;
PageTitle.defaultProps = defaultProps;

PageTitle.fragments = {
  page: gql`
    fragment PageTitlePage on Page {
      id
      internalName
      title
      primary @include(if: $nonDefaultLocale) {
        internalName
        title
      }
      facility {
        ...FacilityAddressFacility
      }
    }

    ${FacilityAddress.fragments.facility}
  `,
};

export default PageTitle;
